import { render, staticRenderFns } from "./CheckupPlusAppointmentsList.vue?vue&type=template&id=19cd461b&scoped=true"
import script from "./CheckupPlusAppointmentsList.vue?vue&type=script&lang=js"
export * from "./CheckupPlusAppointmentsList.vue?vue&type=script&lang=js"
import style0 from "./CheckupPlusAppointmentsList.vue?vue&type=style&index=0&id=19cd461b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd461b",
  null
  
)

export default component.exports